import template from "./pCasemanUserConfig.html";

export function pCasemanUserConfigDirective() {
  'ngInject';

  let directive = {
    restrict: 'E',
    template: template,
    controller: pCasemanUserConfigController,
    controllerAs: 'pCasemanUserConfig',
    bindToController: true
  };

  return directive;
}

class pCasemanUserConfigController {
  constructor($scope, $location, $interval, $q, Auth, Caseman, Notes, Sort, Utils, ConnectionQuality) {
    'ngInject';
    this.$scope = $scope;
    this.$location = $location;
    this.$interval = $interval;
    this.$q = $q;
    this.Auth = Auth;
    this.Caseman = Caseman;
    this.Notes = Notes;
    this.Sort = Sort;
    this.Utils = Utils;
    this.ConnectionQuality = ConnectionQuality;
    this.state = "loading";
    this.matchBlocked = false;

    this.headers = [
      {name: "CASEMAN.USER_KLIX", class: "table-info"},
      {name: "CASEMAN.USER_CASEMAN", class: "table-caseman"}
    ];

    this.Auth.authorize().then(
      (user) => {
        this.user = user;

        //Notes...
        const timeout = this.$interval(() => {this.notes = this.Notes.getNotes();}, 200);
        this.$scope.$on("$destroy", () => {this.$interval.cancel( timeout );});

        let promises = [
          this.Caseman.getUsersByCountryKlix(),
          this.Caseman.getUsersMapperByCountry(),
        ];
        this.$q.all(promises).then(
          (success) => {
            this.usersKlix = success[0].data.sort(this.Sort.abcBy("fullName"));
            this.usersMapper = success[1].data;

            this.usersMapperDisplay = this.usersKlix && this.usersKlix.map( userKlix => {
              let user = this.usersMapper.find(userMapper => userMapper.userId == userKlix.id);
              if(!user) {
                user = {userId: userKlix.id , userName: userKlix.fullName, casemanUserId: null, casemanUserName: null, unmatched: true};
              }
              return user;
            });

            this.state = "loaded";
          },
          (error) => {
            this.state = "error";
            this.Notes.postNote({type: "error", error: error});
          }
        );
      },
      () => {
        this.Auth.handleUnauthorized();
      }
    );

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  refresh() {
    this.Caseman.getUsersMapperByCountry().then(
      (success) => {
        this.usersMapper = success.data;
        this.usersMapperDisplay = this.usersKlix && this.usersKlix.map( userKlix => {
          let user = this.usersMapper.find(userMapper => userMapper.userId == userKlix.id);
          if(!user) {
            user = {userId: userKlix.id , userName: userKlix.fullName, casemanUserId: null, casemanUserName: null, unmatched: true};
          }
          return user;
        });
        this.matchBlocked = this.Utils.blockMatch(this.usersMapperDisplay);
        this.state = "loaded";
      },
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  back() {
    window.history.back();
  }

  editUser(entity) {
    this.userToMatch = {id: entity.casemanUserId, name: entity.casemanUserName};
    this.matchBlocked = this.Utils.blockMatch(this.usersMapperDisplay);
    this.hintName = entity.userName.substr(entity.userName.indexOf(' ')+1, entity.userName.length-1);
    this.Caseman.getUsersByCountryCASEMAN().then(
      (success) => {this.usersCASEMAN = success.data.sort(this.Sort.abcBy("name"));},
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  saveUserMatch(user, userToMatch) {
    this.state = "loading";
    this.Caseman.setUserMapper(user.userId, angular.fromJson(userToMatch).id).then(
      () => {
        this.userToMatch = null;
        this.refresh();
      },
      (error) => {
        this.state = "error";
        this.matchBlocked = this.Utils.blockMatch(this.usersMapperDisplay);
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  deleteUser(user) {
    this.state = "loading";
    this.Caseman.deleteUserMapper(user.userId).then(
      () => {this.refresh();},
      (error) => {
        this.state = "error";
        this.Notes.postNote({type: "error", error: error});
      }
    );
  }

  cancel() {
    this.matchBlocked = this.Utils.blockMatch(this.usersMapperDisplay);
    this.userToMatch = null;
  }

}